import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { FeedbackService } from '../services/feedback.service'
import { NewFeedbackSchema } from '../utils/types/feedback'

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {},
  reducers: {}
})

export const createFeedback = createAsyncThunk(
  'feedback/create',
  async (payload: NewFeedbackSchema) => {
    try {
      const { status } = await FeedbackService.create(payload)
      return { status }
    } catch (error) {
      return Promise.reject(error)
    }
  }
)

export const { reducer: feedbackReducer } = feedbackSlice
